import { useState } from 'react';
import { getGeneratedUrlForUploadedFile } from 'admin/domains/activities/api';

export const useFileDownloader = () => {
  const [downloadUrl, setDownloadUrl] = useState('');
  const [error, setError] = useState();

  const downloadFileUrl = async (blockId, activityResponseId) => {
    try {
      const response = await getGeneratedUrlForUploadedFile(
        blockId,
        activityResponseId
      );
      setDownloadUrl(response.url);
    } catch (error) {
      setDownloadUrl('');
      setError(error);
    }
  };

  const handleDownloadedUrl = (url, fileName) => {
    const link = document.createElement('a');
    link.style.display = 'none';
    link.target = '_blank';
    link.href = url;
    link.download = fileName;

    document.body.appendChild(link);
    link.click();
  };

  return {
    downloadUrl,
    downloadFileUrl,
    handleDownloadedUrl,
    downloadError: error,
  };
};
